import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import TitleScene from './TitleScene';

export default class PauseScene extends Phaser.Scene {
  static get KEY() { return 'PauseScene'; }

  create(pausedScene) {
    this.pausedScene = pausedScene.pausedScene;

    this.pausedScene.pause();

    this.menuBg = ABCyaPhaser.Images.addImage(0,0, 'PausedBg', this).setOrigin(0);
    this.menuBg.y = this.scale.height / 2 - this.menuBg.height;
    this.add.bitmapText(this.menuBg.width / 2, this.menuBg.y + this.menuBg.height / 2, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('paused'), 80, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(.5);

    this.btnResume = ABCyaPhaser.Images.addImage(this.scale.width * 0.3, this.menuBg.y + this.menuBg.height + 40, 'BUTTON_quit', this).setOrigin(0.5, 0)
      .setInteractive()
      .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.unpause, this);

    const resumeLabel = this.add.bitmapText(this.btnResume.x, this.btnResume.y + this.btnResume.height / 2, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.resume'), 46, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(.5);
    resumeLabel.setTintFill(0xefa02e);

    this.btnQuit = ABCyaPhaser.Images.addImage(this.scale.width * 0.7, this.menuBg.y + this.menuBg.height + 40, 'BUTTON_quit', this).setOrigin(0.5, 0)
      .setInteractive()
      .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.quit, this);

    const quitLabel = this.add.bitmapText(this.btnQuit.x, this.btnQuit.y + this.btnQuit.height / 2, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.quit'), 58, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(.5);
    quitLabel.setTintFill(0xefa02e);
  }

  quit() {
    this.pausedScene.stop();
    this.scene.start(TitleScene.KEY);
  }

  unpause() {
    this.pausedScene.resume();
    this.scene.stop();
  }
}